const technologies = [
    "OpenCV",
    "LibTorch",
    "YOLO",
    "ModelZoo",
    "Ultralytics YOLO",
    "Roboflow",
    "Python",
    "PostgreSQL",
    "React",
    "Flask",
    "PyQt6",
    "NumPy",
    "PyTorch",
    "PyTorch Geometric",
    "Jupyter",
    "TensorBoard"
];

export default technologies;